<template lang="pug">
  .v-container.grid-container.u-margin-auto(:class="loadingClass")
    div(v-cloak)
      .row
        .col.s12
          h1.h5.u-weight-bold
            template(v-if="isNewAddress")
              template(v-if="isDigitalProductsOnly") Add Billing Address
              template(v-else) Add a New Shipping Address
            template(v-else)
              template(v-if="isDigitalProductsOnly") Edit Your Billing Address
              template(v-else) Edit Your Shipping Address
      .row.u-mtm
        vue-shipping-input(:shipping-id="shippingAddressId", service="shop", :button-label="isDigitalProductsOnly ? 'Confirm billing address' : 'Ship to this address'", @submit="submit")
      .row
        .col.s12
          router-link.c-btn.c-btn--link-inherit(to="/checkout/shippings") Back
</template>

<script>
import Shipments from '../../../stores/schema/injected/Shipments';
import ShoppingCarts from '../../../stores/schema/ShoppingCarts';
import shippingInputComponent from '../../../components/shippings/ShippingsInput.vue';

export default {
  name: 'input_shipping_address',
  components: {
    'vue-shipping-input': shippingInputComponent
  },
  data() {
    return {
      loading: true
    };
  },
  computed: {
    loadingClass() {
      return {
        'v-loading': this.loading,
        'c-loading': this.loading,
        'c-loading--opacity': this.loading
      };
    },
    shippingAddressId() {
      if (this.selectedShippingAddress) {
        return this.$route.params.id;
      }
      return '';
    },
    isNewAddress() {
      return this.$route.params.id === 'new';
    },
    selectedShippingAddress() {
      return this.$store.getters['shippings/findById'](this.$route.params.id);
    },
    cart() {
      return this.$store.getters['cart/current']({ populate: ['shipments'] });
    },
    isDigitalProductsOnly() {
      return ShoppingCarts.isDigitalProductsOnly(this.cart);
    }
  },
  created() {
    // 住所登録の場合
    if (this.isNewAddress) {
      this.loading = false;
    }
    // 住所編集の場合（住所一覧に指定されたIDの住所が存在する場合）
    else if (this.selectedShippingAddress) {
      this.loading = false;
    }
    // 住所編集の場合（住所一覧に指定されたIDの住所が存在しない場合）
    else {
      this.fetch();
    }
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$store
        .dispatch('shippings/fetchAll')
        .then(() => {
          this.loading = false;

          // 指定されたIDの住所が存在しなかった場合は住所選択画面に戻す
          if (!this.selectedShippingAddress) {
            this.$router.push('/checkout/shippings');
          }
        })
        .catch((error) => {
          this.loading = false;

          this.$alert(
            error.general ||
              'An error occurred. Please wait a moment before trying again.'
          );
        });
    },
    submit() {
      this.loading = true;

      this.$store
        .dispatch('cart/changeCartShipping', {
          wishlistId: this.cart.wishlistId
        })
        .then(() => {
          this.loading = false;

          // 全てのShipmentsが配送不可の場合はエラーを表示しつつ住所選択画面に戻す
          if (Shipments.isAllShipmentsUndeliverable(this.cart.shipments)) {
            this.$alert('All shipments are undeliverable');
            this.$router.push('/checkout/shippings');
            return false;
          }

          this.$router.push('/checkout').catch(() => {});
        })
        .catch((error) => {
          this.loading = false;

          this.$alert(
            error.general ||
              'An error occurred. Please wait a moment before trying again.'
          );
        });
    }
  }
};
</script>

<style scoped>
.v-container {
  max-width: 950px;
  padding: 0;
}

.v-loading {
  min-height: 50vh;
}
/* IOSにてinputにfocus時zoomされないようにする対応 */
.form-ctl {
  font-size: 16px;
  font-size: 1.6rem;
}
</style>
